import * as styles from './Thumbnails.css';
import { IMedia } from '../../types';

interface IThumbnails {
  media: Pick<IMedia, 'previewUrl'>[];
}

export const Thumbnails = (props: IThumbnails) => {
  const { media } = props;

  return (
    <div className={styles['thumbnails']}>
      {media.map(media => (
        <img key={media.previewUrl} src={media.previewUrl} loading="lazy" decoding="async" />
      ))}
    </div>
  );
};
